/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Nohraclinic API
 * API do Nohraclinic. Sessão web por cookie httpOnly; mobile por bearer. As rotas sob /v1/auth/* que não estão aqui são servidas pelo handler do better-auth, restrito a uma allowlist (ver src/modules/auth/auth.mount.ts): sign-in/email, sign-out, get-session, verify-email, send-verification-email, request-password-reset e reset-password. O cadastro entra só por POST /v1/auth/registro.
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ErroResponse,
  ListaDeResumosResponse,
  MetricasControllerListarParams,
  MetricasDeProdutosResponse,
  MetricasDoParceiroResponse,
  MetricasParceirosControllerDeProdutosParams,
  MetricasParceirosControllerDoParceiroParams,
  MetricasParceirosControllerRankingParams,
  PaginaDeAvaliacoesResponse,
  RankingDeParceirosResponse
} from '../model';

import { httpClient } from '../../http-client.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getMetricasControllerListarUrl = (params?: MetricasControllerListarParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/metricas/avaliacoes-atendimento?${stringifiedParams}` : `/v1/admin/metricas/avaliacoes-atendimento`
}

/**
 * @summary Lista as avaliações de atendimento, paginado. Filtro por assessor.
 */
export const metricasControllerListar = async (params?: MetricasControllerListarParams, options?: Parameters<typeof httpClient>[1]): Promise<PaginaDeAvaliacoesResponse> => {

  return httpClient<PaginaDeAvaliacoesResponse>(getMetricasControllerListarUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMetricasControllerListarQueryKey = (params?: MetricasControllerListarParams,) => {
    return [
    `/v1/admin/metricas/avaliacoes-atendimento`, ...(params ? [params] : [])
    ] as const;
    }


export const getMetricasControllerListarQueryOptions = <TData = Awaited<ReturnType<typeof metricasControllerListar>>, TError = ErroResponse>(params?: MetricasControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricasControllerListarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricasControllerListar>>> = ({ signal }) => metricasControllerListar(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricasControllerListar>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricasControllerListarQueryResult = NonNullable<Awaited<ReturnType<typeof metricasControllerListar>>>
export type MetricasControllerListarQueryError = ErroResponse


export function useMetricasControllerListar<TData = Awaited<ReturnType<typeof metricasControllerListar>>, TError = ErroResponse>(
 params: undefined |  MetricasControllerListarParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerListar>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasControllerListar>>,
          TError,
          Awaited<ReturnType<typeof metricasControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasControllerListar<TData = Awaited<ReturnType<typeof metricasControllerListar>>, TError = ErroResponse>(
 params?: MetricasControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerListar>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasControllerListar>>,
          TError,
          Awaited<ReturnType<typeof metricasControllerListar>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasControllerListar<TData = Awaited<ReturnType<typeof metricasControllerListar>>, TError = ErroResponse>(
 params?: MetricasControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Lista as avaliações de atendimento, paginado. Filtro por assessor.
 */

export function useMetricasControllerListar<TData = Awaited<ReturnType<typeof metricasControllerListar>>, TError = ErroResponse>(
 params?: MetricasControllerListarParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerListar>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricasControllerListarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMetricasControllerResumoUrl = () => {




  return `/v1/admin/metricas/avaliacoes-atendimento/resumo`
}

/**
 * @summary Média de nota e % de resolvidos, por assessor
 */
export const metricasControllerResumo = async ( options?: Parameters<typeof httpClient>[1]): Promise<ListaDeResumosResponse> => {

  return httpClient<ListaDeResumosResponse>(getMetricasControllerResumoUrl(),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMetricasControllerResumoQueryKey = () => {
    return [
    `/v1/admin/metricas/avaliacoes-atendimento/resumo`
    ] as const;
    }


export const getMetricasControllerResumoQueryOptions = <TData = Awaited<ReturnType<typeof metricasControllerResumo>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricasControllerResumoQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricasControllerResumo>>> = ({ signal }) => metricasControllerResumo({ signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricasControllerResumo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricasControllerResumoQueryResult = NonNullable<Awaited<ReturnType<typeof metricasControllerResumo>>>
export type MetricasControllerResumoQueryError = unknown


export function useMetricasControllerResumo<TData = Awaited<ReturnType<typeof metricasControllerResumo>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerResumo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof metricasControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasControllerResumo<TData = Awaited<ReturnType<typeof metricasControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerResumo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasControllerResumo>>,
          TError,
          Awaited<ReturnType<typeof metricasControllerResumo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasControllerResumo<TData = Awaited<ReturnType<typeof metricasControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Média de nota e % de resolvidos, por assessor
 */

export function useMetricasControllerResumo<TData = Awaited<ReturnType<typeof metricasControllerResumo>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasControllerResumo>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricasControllerResumoQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMetricasParceirosControllerRankingUrl = (params?: MetricasParceirosControllerRankingParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/metricas/parceiros?${stringifiedParams}` : `/v1/admin/metricas/parceiros`
}

/**
 * @summary Ranking de parceiros e totais da janela (7, 30 ou 90 dias)
 */
export const metricasParceirosControllerRanking = async (params?: MetricasParceirosControllerRankingParams, options?: Parameters<typeof httpClient>[1]): Promise<RankingDeParceirosResponse> => {

  return httpClient<RankingDeParceirosResponse>(getMetricasParceirosControllerRankingUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMetricasParceirosControllerRankingQueryKey = (params?: MetricasParceirosControllerRankingParams,) => {
    return [
    `/v1/admin/metricas/parceiros`, ...(params ? [params] : [])
    ] as const;
    }


export const getMetricasParceirosControllerRankingQueryOptions = <TData = Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError = ErroResponse>(params?: MetricasParceirosControllerRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricasParceirosControllerRankingQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricasParceirosControllerRanking>>> = ({ signal }) => metricasParceirosControllerRanking(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricasParceirosControllerRankingQueryResult = NonNullable<Awaited<ReturnType<typeof metricasParceirosControllerRanking>>>
export type MetricasParceirosControllerRankingQueryError = ErroResponse


export function useMetricasParceirosControllerRanking<TData = Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError = ErroResponse>(
 params: undefined |  MetricasParceirosControllerRankingParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasParceirosControllerRanking>>,
          TError,
          Awaited<ReturnType<typeof metricasParceirosControllerRanking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasParceirosControllerRanking<TData = Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError = ErroResponse>(
 params?: MetricasParceirosControllerRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasParceirosControllerRanking>>,
          TError,
          Awaited<ReturnType<typeof metricasParceirosControllerRanking>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasParceirosControllerRanking<TData = Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError = ErroResponse>(
 params?: MetricasParceirosControllerRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Ranking de parceiros e totais da janela (7, 30 ou 90 dias)
 */

export function useMetricasParceirosControllerRanking<TData = Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError = ErroResponse>(
 params?: MetricasParceirosControllerRankingParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerRanking>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricasParceirosControllerRankingQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMetricasParceirosControllerDoParceiroUrl = (id: string,
    params?: MetricasParceirosControllerDoParceiroParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/metricas/parceiros/${id}?${stringifiedParams}` : `/v1/admin/metricas/parceiros/${id}`
}

/**
 * @summary Resumo e série diária de um parceiro, com os dias vazios zerados
 */
export const metricasParceirosControllerDoParceiro = async (id: string,
    params?: MetricasParceirosControllerDoParceiroParams, options?: Parameters<typeof httpClient>[1]): Promise<MetricasDoParceiroResponse> => {

  return httpClient<MetricasDoParceiroResponse>(getMetricasParceirosControllerDoParceiroUrl(id,params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMetricasParceirosControllerDoParceiroQueryKey = (id: string,
    params?: MetricasParceirosControllerDoParceiroParams,) => {
    return [
    `/v1/admin/metricas/parceiros/${id}`, ...(params ? [params] : [])
    ] as const;
    }


export const getMetricasParceirosControllerDoParceiroQueryOptions = <TData = Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError = ErroResponse>(id: string,
    params?: MetricasParceirosControllerDoParceiroParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricasParceirosControllerDoParceiroQueryKey(id,params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>> = ({ signal }) => metricasParceirosControllerDoParceiro(id,params, { signal, ...requestOptions });





   return  { queryKey, queryFn, enabled: id !== null && id !== undefined, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricasParceirosControllerDoParceiroQueryResult = NonNullable<Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>>
export type MetricasParceirosControllerDoParceiroQueryError = ErroResponse


export function useMetricasParceirosControllerDoParceiro<TData = Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError = ErroResponse>(
 id: string,
    params: undefined |  MetricasParceirosControllerDoParceiroParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>,
          TError,
          Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasParceirosControllerDoParceiro<TData = Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError = ErroResponse>(
 id: string,
    params?: MetricasParceirosControllerDoParceiroParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>,
          TError,
          Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasParceirosControllerDoParceiro<TData = Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError = ErroResponse>(
 id: string,
    params?: MetricasParceirosControllerDoParceiroParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Resumo e série diária de um parceiro, com os dias vazios zerados
 */

export function useMetricasParceirosControllerDoParceiro<TData = Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError = ErroResponse>(
 id: string,
    params?: MetricasParceirosControllerDoParceiroParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDoParceiro>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricasParceirosControllerDoParceiroQueryOptions(id,params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getMetricasParceirosControllerDeProdutosUrl = (params?: MetricasParceirosControllerDeProdutosParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/v1/admin/metricas/produtos?${stringifiedParams}` : `/v1/admin/metricas/produtos`
}

/**
 * @summary Importações por produto. Zero até o módulo de receituários emitir o evento.
 */
export const metricasParceirosControllerDeProdutos = async (params?: MetricasParceirosControllerDeProdutosParams, options?: Parameters<typeof httpClient>[1]): Promise<MetricasDeProdutosResponse> => {

  return httpClient<MetricasDeProdutosResponse>(getMetricasParceirosControllerDeProdutosUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getMetricasParceirosControllerDeProdutosQueryKey = (params?: MetricasParceirosControllerDeProdutosParams,) => {
    return [
    `/v1/admin/metricas/produtos`, ...(params ? [params] : [])
    ] as const;
    }


export const getMetricasParceirosControllerDeProdutosQueryOptions = <TData = Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError = unknown>(params?: MetricasParceirosControllerDeProdutosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getMetricasParceirosControllerDeProdutosQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>> = ({ signal }) => metricasParceirosControllerDeProdutos(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type MetricasParceirosControllerDeProdutosQueryResult = NonNullable<Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>>
export type MetricasParceirosControllerDeProdutosQueryError = unknown


export function useMetricasParceirosControllerDeProdutos<TData = Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError = unknown>(
 params: undefined |  MetricasParceirosControllerDeProdutosParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>,
          TError,
          Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasParceirosControllerDeProdutos<TData = Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError = unknown>(
 params?: MetricasParceirosControllerDeProdutosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>,
          TError,
          Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>
        > , 'initialData'
      >, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useMetricasParceirosControllerDeProdutos<TData = Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError = unknown>(
 params?: MetricasParceirosControllerDeProdutosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Importações por produto. Zero até o módulo de receituários emitir o evento.
 */

export function useMetricasParceirosControllerDeProdutos<TData = Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError = unknown>(
 params?: MetricasParceirosControllerDeProdutosParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof metricasParceirosControllerDeProdutos>>, TError, TData>>, request?: SecondParameter<typeof httpClient>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getMetricasParceirosControllerDeProdutosQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






